export const TRACKED_STATUSES = [
  // blueexpress
  'PU',
  'LD',
  'DL',
  // chilexpress
  '4',
  '13_0',
  '14_0',
  // fazt
  'Creado',
  'Preparado',
  'Retirado',
  'En deposito',
  'En ruta',
  'Completado',
  // Movilibox
  'ENT',
  // starken
  'ENTREGADO'
]

export default TRACKED_STATUSES
